import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import AgencyStore from 'stores/Model/Agency/AgencyStore';
import OptionStore from 'stores/Model/Integration/Option/OptionStore';
import * as constants from 'Constants';
import { deserializeWithMappers } from 'stores/Utils';


class AgenciesPageStore {

  @setter @observable agencies;
  @setter @observable currentPage;
  @setter @observable numPages;
  @setter @observable numRecords;
  @setter @observable recordExists;

  @setter @observable paramPage;
  @setter @observable paramKeyword;
  @setter @observable paramMinPrice;
  @setter @observable paramMaxPrice;
  @setter @observable paramCountries;
  @setter @observable paramLanguages;
  @setter @observable paramSpecialities;
  @setter @observable paramPlatforms;

  @setter @observable countryOptions;
  @setter @observable languageOptions;
  @setter @observable specialityOptions;
  @setter @observable platformOptions;
  @setter @toggle @observable loaded;

  constructor() {
    this.reset();
  }

  reset() {
    this.agencies = [];
    this.currentPage = 0;
    this.numPages = 0;
    this.numRecords = 0;
    this.recordExists = false;

    this.paramPage = null;
    this.paramKeyword = null;
    this.paramMinPrice = null;
    this.paramMaxPrice = null;
    this.paramCountries = [];
    this.paramLanguages = [];
    this.paramSpecialities = [];
    this.paramPlatforms = [];

    this.countryOptions = [];
    this.languageOptions = [];
    this.specialityOptions = [];
    this.platformOptions = [];
    this.loaded = false;
  }

  getDeserializeMappers() {
    return [
      {"field": "agencies", "accessor": "paginator.results", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": AgencyStore},
      {"field": "currentPage", "accessor": "paginator.current_page"},
      {"field": "numPages", "accessor": "paginator.num_pages"},
      {"field": "numRecords", "accessor": "paginator.num_records"},

      {"field": "countryOptions", "accessor": "country_options", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": OptionStore},
      {"field": "languageOptions", "accessor": "language_options", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": OptionStore},
      {"field": "specialityOptions", "accessor": "speciality_options", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": OptionStore},
      {"field": "platformOptions", "accessor": "platform_options", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": OptionStore},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @action deserializeRefresh(data) {
    let mappers = [
      {"field": "agencies", "accessor": "paginator.results", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": AgencyStore},
      {"field": "currentPage", "accessor": "paginator.current_page"},
      {"field": "numPages", "accessor": "paginator.num_pages"},
      {"field": "numRecords", "accessor": "paginator.num_records"},
    ];

    deserializeWithMappers(this, mappers, data);
  }

  @action setFields(data) {
    let self = this;
    for (var key in data) {
      let value = data[key];
      self[key] = value;
    }
  }

  @computed get params() {
    const data = {};
    data['page'] = this.paramPage;
    data['keyword'] = this.paramKeyword;
    data['min_price'] = this.paramMinPrice;
    data['max_price'] = this.paramMaxPrice;
    data['countries'] = this.paramCountries.join(",");
    data['languages'] = this.paramLanguages.join(",");
    data['specialities'] = this.paramSpecialities.join(",");
    data['platforms'] = this.paramPlatforms.join(",");
    return data;
  }

  @computed get countrySelectOptions() {
    return this.countryOptions.map((option) => {
      return {'label': option.label, 'value': option.id};
    });
  }

  @computed get languageSelectOptions() {
    return this.languageOptions.map((option) => {
      return {'label': option.label, 'value': option.id};
    });
  }

  @computed get specialitySelectOptions() {
    return this.specialityOptions.map((option) => {
      return {'label': option.label, 'value': option.id};
    });
  }

  @computed get platformSelectOptions() {
    return this.platformOptions.map((option) => {
      return {'label': option.label, 'value': option.id};
    });
  }

}


const agenciesPageStore = new AgenciesPageStore();
export default agenciesPageStore;
export { AgenciesPageStore };
